import React, { Component } from 'react'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const options = {
  timing: 200,
}

class Alert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      showContent: false,
      leave: false,
    }

    this.options = options
    this.handleAlert = this.handleAlert.bind(this)
  }

  componentDidMount() {
    document.body.classList.add('no-scroll')

    setTimeout(
      () => this.setState({ show: true, showContent: true }),
      this.options.timing
    )
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll')
  }

  handleAlert(e) {
    const { handleAlert, preventDefault } = this.props

    if (preventDefault) e.preventDefault()

    this.setState({ leave: true, show: false, showContent: false })

    setTimeout(() => handleAlert(), this.options.timing)
  }

  render() {
    const { text, textButton, translate, size } = this.props
    const { show, showContent, leave } = this.state

    const componentClass = classNames('modal', 'modal-enter', {
      'modal-show': show,
      'modal-leave': leave,
    })

    const contentClass = classNames('modal-content', 'modal-content-enter', {
      'modal-content-show': showContent,
      'modal-content-leave': leave,
      [`modal-content-${size}`]: size,
    })

    return (
      <div className={componentClass}>
        <div className={contentClass} data-modal-size>
          <div className='modal-body'>
            <div className='container-fluid align-center'>
              <Row>
                <Col xs={12}>
                  <p>{text}</p>
                </Col>
              </Row>

              <Row>
                <Col xsOffset={2} xs={8} mdOffset={4} md={4}>
                  <button
                    data-alert-button
                    className='button button-primary button-full'
                    onClick={this.handleAlert}
                  >
                    {translate(textButton)}
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Alert.defaultProps = {
  textButton: 'confirmModal.confirm',
}

Alert.propTypes = {
  translate: PropTypes.func,
  handleAlert: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  textButton: PropTypes.string,
  size: PropTypes.string.isRequired,
  preventDefault: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
}

export default Alert
